<template>
  <component :is="embedded ? 'div' : 'v-main'">
    <component :is="embedded ? 'div' : 'v-container'" v-bind="embedded ? {} : { fluid: true }">
      <v-card :elevation="embedded ? 0 : 6" :rounded="embedded ? undefined : 'xxl'">
        <!-- Embedded (dialog) use gets its banner header from AppDialog instead. -->
        <v-card-title v-if="!embedded" class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Banner
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.title"
                outlined
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <label for="">Upload Image</label>
              <input
                type="file"
                id="image_path"
                name="image_path"
                ref="image_path"
                accept="image/*"
                @change="onFileChange"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.image_path.value = null), (image_url = null)"
                >Remove</v-btn
              >
              <div id="preview" v-if="image_url" class="mt-3">
                <label>Image Preview</label><br />
                <img :src="image_url" style="height: 120px; width: auto; border-radius: 8px;" />
              </div>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn text class="mr-2" @click="embedded ? $emit('close') : $router.back()">Cancel</v-btn>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Banner
          </v-btn>
        </v-card-text>
      </v-card>
    </component>
  </component>
</template>
<script>
import axios from "axios";

export default {
  name: "BannerEditPage",
  props: {
    // When true, this form is rendered inside another page's dialog (e.g.
    // the Banners list's inline "Edit Banner") instead of its own routed
    // page - the id comes from the `bannerId` prop rather than the route,
    // and it emits `saved`/`close` rather than navigating away.
    embedded: { type: Boolean, default: false },
    bannerId: { type: String, default: null },
  },
  data() {
    return {
      form: {
        title: "",
        image_path: "",
        is_active: false,
      },
      image_url: null,
      old_json: {},
      isLoading: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters["errors/getErrors"] || {};
    },
  },
  mounted() {
    this.$store.dispatch("errors/setErrors", {});
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.bannerId || this.$route.params.bannerId;
      await axios
        .get(`/banners/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
          this.image_url = this.form.image_path
            ? `${this.mediaUrl}${this.form.image_path}`
            : null;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    onFileChange() {
      const file = this.$refs.image_path.files[0];
      if (file) {
        this.image_url = URL.createObjectURL(file);
      }
    },
    async save() {
      try {
        this.isLoading = true;
        this.$store.dispatch("errors/setErrors", {});
        const encryptedId = this.bannerId || this.$route.params.bannerId;
        await axios.patch(`/banners/${encryptedId}`, this.form);
        if (this.$refs.image_path && this.$refs.image_path.files[0]) {
          await this.handleFileUpload();
        }
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
        if (this.embedded) {
          this.$emit("saved");
          this.$emit("close");
        } else {
          this.$router.push("/banners");
        }
      } catch (e) {
        console.log(e);
        this.isLoading = false;
        if (e.response && e.response.data && e.response.data.errors) {
          this.$store.dispatch("errors/setErrors", e.response.data.errors);
        }
      }
    },
    async handleFileUpload() {
      let formData = new FormData();
      formData.append("id", this.form.id);
      formData.append("image_path", this.$refs.image_path.files[0]);
      await axios
        .post("upload_banners_image", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
